import { styled } from "styled-components";
import * as Style from '../../containers/AccountForm/StyleAccountForm'

export const Container = styled(Style.Container)`
  flex-direction: column;
  width: 100%;
  font-size: 1.4rem;
  color: var(--red);
`

export const Button = styled(Style.Button)`
  
`
export const Box = styled.div`
  display: flex;
  gap: 8px;
`